import { useState } from "react";

import hcmusLogo from "../../public/hcmus2.png";
import Circle from "../LogoSVG/Circle";

export const HcmusDesktop = () => {
  return (
    <div className="flex flex-row items-start">
      <div className="w-[200px] overflow-hidden mr-10 bg-white rounded p-4 mt-2">
        <img
          src={hcmusLogo}
          alt="logo"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex flex-col justify-start">
        <p className="mb-2 text-[18px] font-medium">
          University of Science - Vietnam National University | Vietnam
        </p>
        <ul className="text-gray-5">
          <li>
            <div className="flex flex-row ">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <p className="text-gray-4">
                Bachelor of Science - BS, Computer Science | 2020 - 2024
              </p>
            </div>
          </li>

          <li>
            <div className="flex flex-row mt-1">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <div className="text-gray-4">
                Supervisor:&nbsp;
                <a
                  className="text-custom-green"
                  href="https://www.fit.hcmus.edu.vn/~dbtien/"
                  target="_blank"
                >
                  Prof. Tien Ba Dinh
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
